import { render, staticRenderFns } from "./auditDetail.vue?vue&type=template&id=c1998d38&scoped=true&"
import script from "./auditDetail.vue?vue&type=script&lang=js&"
export * from "./auditDetail.vue?vue&type=script&lang=js&"
import style0 from "./auditDetail.vue?vue&type=style&index=0&id=c1998d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1998d38",
  null
  
)

export default component.exports